import * as d from '@/utils/dataUtils'

export const defaultFormModel = {
  name: '',
  legalForm: null,
  email: '',
  website: '',
  idMainLocation: null,
  address: '',
  logo: '',
}

export function prepareCompanyForLoad (data: any): any {
  return {
    ...data,
    legalForm: d.loadSelect(data.legalForm),
    idMainLocation: d.loadSelect(data.idMainLocation),
  }
}

export async function prepareCompanyForSave (data: any): Promise<any> {
  const payload = {
    ...data,
    legalForm: d.saveSelect(data.legalForm),
    idMainLocation: d.saveSelect(data.idMainLocation),
  }

  // Der ImagePicker liefert ein File-Objekt; das Backend erwartet logo als
  // Base64-String. Ohne Konvertierung wird das File zu {} serialisiert und
  // der Save-Request scheitert mit 400 (Invalid JSON).
  if (data.logo instanceof File) {
    payload.logo = await d.fileToBase64(data.logo)
  } else if (data.logo == null) {
    payload.logo = ''
  }

  return payload
}

export function prepareLocationItem (data: any): any {
  return {
    ...data,
    iconType: 'locations',
  }
}
